// src/Callback.js
import React, { useEffect, useState } from "react";
import { getUserManager } from "./AuthService";

export default function Callback() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      const userManager = getUserManager();
      try {
        const user = await userManager.signinRedirectCallback();
        localStorage.setItem("user", JSON.stringify(user));
        // Save access token for API calls
        localStorage.setItem("jwtToken", user.access_token);
        setLoading(false);
        window.location.href = "/";
      } catch (err) {
        console.error("Error handling callback:", err);
        setLoading(false);
      }
    };
    run();
  }, []);

  return <div>{loading ? "Logging in..." : "Redirecting..."}</div>;
}